import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import common from '@/utils/common';
import LOGIN_TYPE from '../constants/loginType';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

Vue.use(Vuex);

const initAxios = () => {
  axios.defaults.baseURL = process.env.API_BASE_URL;
};

const enhanceAccessToken = () => {
  const { accessToken } = localStorage;
  if (!accessToken) return;
  axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
};

initAxios();
enhanceAccessToken();

export default new Vuex.Store({
  state: {
    userSeqId: localStorage.getItem('userSeqId'),
    userName: localStorage.getItem('userName'),
    userEmail: localStorage.getItem('userEmail'),
    accessToken: localStorage.getItem('accessToken'),
    refreshToken: localStorage.getItem('refreshToken'),
    tagList: [],
    showMenu: false,
    language: common.methods.getLanguage(),
    jobs: JSON.parse(localStorage.getItem('jobs')),
    qCnt: localStorage.getItem('qCnt'),
    profileImage: localStorage.getItem('profileImage'),
    loginType: localStorage.getItem('loginType')
      ? localStorage.getItem('loginType')
      : LOGIN_TYPE.NONE,
    lastSelectedMatchTab:
      localStorage.getItem('lastSelectedMatchTab') || 'friend',

    // 회원가입 시, 사용하는 임시 데이터.
    tmpUserEmail: '',
    tmpUserPassword: '',
    tmpUserNickname: '',
    tmpUserName: '',
    tmpUserBirth: '',
    tmpUserSex: '',
    tmpUserEducation: '',
    tmpValidEmailFlag: true,
    tmpValidPasswordFlag: true,
    tmpValidNicknameFlag: true,
    tmpValidNameFlag: true,
    tmpTagList: [],
    tmpProfileImage: '',
    tmpClientId: '',
  },
  getters,
  mutations,
  actions,
});



// WEBPACK FOOTER //
// ./src/store/index.js